import React from 'react';

import { Card, PaperProps } from '@mui/material';

export const Paper: React.FunctionComponent<PaperProps> = function ({ sx, ...props }) {
    return (
        <Card
            {...props}
            sx={{ padding: '25px 50px 25px 50px', ...sx }}
        />
    );
};
